import React from 'react';
import { Select } from 'antd';
import { useQueryWithStore } from 'react-admin';
import { Field } from '../Form';

/**
 * Services the current team owns. The list is small and the picker needs all
 * of it — a truncated page would silently hide services from the dropdown.
 */
export const useServiceOptions = () => {
    const { data, loading } = useQueryWithStore({
        type: 'getList',
        resource: 'services',
        payload: {
            pagination: { page: 1, perPage: 200 },
            sort: { field: 'name', order: 'ASC' },
            filter: {},
        },
    });

    return {
        options: ((data as any[]) || []).map((service) => ({ value: service.id, label: service.name })),
        loading,
    };
};

const ServiceField = ({
    locked,
    hint,
    span = 6,
}: {
    locked?: boolean;
    hint?: React.ReactNode;
    span?: number;
}) => {
    const { options, loading } = useServiceOptions();

    return (
        <Field
            name="service"
            label="Service"
            span={span}
            hint={hint}
            rules={[{ required: true, message: 'Choose the service this applies to' }]}
        >
            <Select
                placeholder="Select a service"
                options={options}
                loading={loading}
                disabled={locked}
                showSearch={{ optionFilterProp: 'label' }}
            />
        </Field>
    );
};

export default ServiceField;
